const single = [
	'services',
	'feature',
	'process',
	'portfolio',
	'testimonials',
	'blog',
	'developers',
	'contact'
]

export default single
